/**
 * @generated SignedSource<<6f96dfe3e35e25316af907da39d47f63>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type printingMethodEditor_ProductCountQuery$variables = {
  id: string;
};
export type printingMethodEditor_ProductCountQuery$data = {
  readonly printType: {
    readonly models: ReadonlyArray<{
      readonly modelID: string;
    }>;
  } | null;
};
export type printingMethodEditor_ProductCountQuery = {
  response: printingMethodEditor_ProductCountQuery$data;
  variables: printingMethodEditor_ProductCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PrintTypeModel",
  "kind": "LinkedField",
  "name": "models",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelID",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printingMethodEditor_ProductCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PrintType",
        "kind": "LinkedField",
        "name": "printType",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "printingMethodEditor_ProductCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PrintType",
        "kind": "LinkedField",
        "name": "printType",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1904f8c97ae94d78a04190c50761ad4",
    "id": null,
    "metadata": {},
    "name": "printingMethodEditor_ProductCountQuery",
    "operationKind": "query",
    "text": "query printingMethodEditor_ProductCountQuery(\n  $id: ID!\n) {\n  printType(id: $id) {\n    models {\n      modelID\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "119c600e812819fb77ae4b24ef7a6f4d";

export default node;
